
export default {
    _app : null,
    init() {
        this._app = document.querySelector('#js_members');

        if (!this._app) {
            return;
        }
        // console.log(this._app);

        new Vue({
            el        : this._app,
            delimiters: ['@{', '}'],
            data      : {
                items : [],
                municipalities : [],
                selectedMunicipalities : [],
                selectedTags : [],
                showFilters : true,
                tags : [],
                query : '',
            },
            created() {
                const el = document.querySelector('#js_members')

                if (typeof el.dataset.items === 'string') {
                    this.items = JSON.parse(el.dataset.items);
                    this.setupFilters();
                    this.getQueryString();
                }
            },

            methods:
            {
                getItemLink(member)
                {
                    return  `/min-side/medlemmer?member_id=${member.id}`;
                },

                getItemImage(member)
                {
                    return typeof member.thumbnail === 'string' && member.thumbnail.length ?
                        member.thumbnail :
                        '/resources/img/placeholder-members.jpg';
                },

                setupFilters()
                {
                    const municipalities = new Set();
                    const tags = new Set();

                    const nameAttr = 'name'; // 'name_en' for english
                    this.items.forEach((p) => {
                        if (p.tags.length) {
                            p.tags.forEach((pt) => tags.add(pt[nameAttr]));
                        }

                        // console.log(typeof p.municipality === 'string');
                        if (p.municipality && p.municipality.trim()) {
                            municipalities.add(p.municipality);
                        }

                        this.tags = tags;
                        this.municipalities  = [...municipalities].sort();
                    });
                },

                updateQueryString()
                {
                    let queryParams = `?`;

                    const params = new URLSearchParams({
                        query: this.query,
                        municipality: this.selectedMunicipalities,
                        tags: this.selectedTags,
                    });

                    const origin   = window.location.origin;
                    const pathname = window.location.pathname;
                    let url = origin + pathname + '?' + params.toString();

                    history.replaceState({}, null, url);
                },

                getQueryString()
                {
                    const params  = new URLSearchParams(window.location.search);

                    // query
                    const search  = params.get('query');
                    this.query = search ? search.replace(/\s+/g,' ').trim() : '';

                    const municipality = params.get('municipality');
                    const tags = params.get('tags');

                    // this.selectedCategories     = params.getAll('kategori[]');
                    this.selectedMunicipalities = municipality ? municipality.split(',') : [];
                    this.selectedTags = tags ? tags.split(',') : [];
                },

                toggleFilters()
                {
                    this.showFilters = ! this.showFilters;
                }
            },
            computed: {
                filteredItems()
                {
                    let results = [];

                    let query = this.query.toLowerCase();

                    this.items.forEach((item) => {
                        let passedQuery = query.length < 3 || item.name.toLowerCase().includes(query);
                        let passedMunicipalities = this.selectedMunicipalities.length === 0 || this.selectedMunicipalities.includes(item.municipality);

                        let tagNames = item.tags.map((t) => t.name);
                        let passedTags = this.selectedTags.length === 0 || this.selectedTags.some(r=> tagNames.includes(r));

                        if (passedQuery && passedMunicipalities && passedTags) {
                            results.push(item);
                        }
                    });

                    return results;
                },
                runtimeClasses()
                {
                    return this.showFilters ? ' filters-visible ' : ' filters-hidden ';
                }

            }
        });
    },

}